var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14546 11.3808C11.2494 11.3808 12.955 9.67518 12.955 7.57124C12.955 5.4673 11.2494 3.76172 9.14546 3.76172C7.04152 3.76172 5.33594 5.4673 5.33594 7.57124C5.33594 9.67518 7.04152 11.3808 9.14546 11.3808Z",
    fill: "#141BEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14446 12.2852C5.32732 12.2852 2.21875 14.8452 2.21875 17.9994C2.21875 18.2128 2.38637 18.3804 2.5997 18.3804H15.6892C15.9026 18.3804 16.0702 18.2128 16.0702 17.9994C16.0702 14.8452 12.9616 12.2852 9.14446 12.2852Z",
    fill: "#141BEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2852 19.2617C17.2182 19.2617 18.7852 17.6947 18.7852 15.7617C18.7852 13.8287 17.2182 12.2617 15.2852 12.2617C13.3522 12.2617 11.7852 13.8287 11.7852 15.7617C11.7852 17.6947 13.3522 19.2617 15.2852 19.2617Z",
    fill: "#141BEB",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7ba2e233b917330633d1401d5fee57e8.svg";
export { ForwardRef as ReactComponent };